import React from 'react';
import styled, { keyframes } from 'styled-components';

const MobileRedirect = () => {
      const stars = generateStars(120); 
  return (
    <Wrapper>
     <StarsWrapper>
        {stars.map(star => (
          <Star
            key={star.id}
           style={{
  top: `${star.top}%`,
  left: `${star.left}%`,
  width: `${star.size}px`,
  height: `${star.size}px`,
  animationDelay: `${star.delay}s`,
  backgroundColor: ['#fff', '#0ff', '#f0f', '#ccc'][Math.floor(Math.random() * 4)],
}}

          />
        ))}
      </StarsWrapper>

      <MessageBox>
        <h1>🚫 Mobile Not Supported</h1>
        <p>
          This site is designed for desktop only.
          <br />
          Please visit on a PC for the full experience.
        </p>
        <Signature>~ Basieem 👾</Signature>
      </MessageBox>
    </Wrapper>
  );
};

export default MobileRedirect;




const moveStars = keyframes`
  from {
    background-position: 0 0;
  }
  to {
    background-position: 1000px 1000px;
  }
`;

const Wrapper = styled.div`
  font-family: 'Press Start 2P', monospace;
  background-color: #0f0f23;
  color: #fff;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  text-align: center;
  padding: 2rem;
`;

const generateStars = (count = 120) => {
  return Array.from({ length: count }).map((_, i) => ({
    id: i,
    top: Math.random() * 100,
    left: Math.random() * 100,
    size: Math.random() * 2 + 1,
    delay: Math.random() * 5,
  }));
};
const twinkle = keyframes`
  0%, 100% { opacity: 0.6; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.2); }
`;

const drift = keyframes`
  0% { transform: translate(0px, 0px); }
  50% { transform: translate(2px, -2px); }
  100% { transform: translate(0px, 0px); }
`;


const Star = styled.span`
  position: absolute;
  background: white;
  border-radius: 50%;
  pointer-events: none;
  opacity: 0.8;
  animation: ${twinkle} 2s ease-in-out infinite, ${drift} 5s ease-in-out infinite;
`;


const StarsWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 0;
  overflow: hidden;
`;

const MessageBox = styled.div`
  border: 3px solid #00ffff;
  background: #1e1e3f;
  padding: 2rem;
  max-width: 500px;
  z-index: 2;
  box-shadow: 0 0 20px #00ffff;

  h1 {
    color: #ffff00;
    margin-bottom: 1rem;
    font-size: 1.2rem;
  }

  p {
    font-size: 0.9rem;
    line-height: 1.5;
    color: #ffffffcc;
  }
`;

const Signature = styled.p`
  margin-top: 2rem;
  font-size: 0.7rem;
  color: #ccc;
`;

